// src/components/MusicStreamingSecondSection/MusicStreamingSecondSection.js

import React from 'react';
import { Container, Typography, Divider, Grid, Button } from '@mui/material';
import { platforms } from '../../../utilis/platformsData';
import './MusicStreamingSecondSection.scss';
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

const MusicStreamingSecondSection = () => {
    const navigate = useNavigate()

    const handleJoinNow = () => {
        window.scrollTo(0, 0);
        navigate('/pricing/1')
    }
    return (
        <section className="music-streaming-second-section">
            <Container>
                {platforms.map((platform, index) => (
                    <React.Fragment key={index}>
                        <Grid container spacing={2} className="platform-item">
                            <Grid item xs={12} md={2} className="logo-container">
                                <img src={platform.logo} alt={platform.name} className="platform-logo" />
                            </Grid>
                            <Grid className="item-container" item xs={12} md={10}>
                                <Typography variant="h3" className="platform-title">
                                    {platform.name}
                                </Typography>
                                <Typography variant="body1" className="platform-description">
                                    {platform.description}
                                </Typography>
                                <Typography variant="subtitle1" className="platform-strength">
                                    <strong>Strength:</strong> {platform.strength}
                                </Typography>
                                <Typography variant="subtitle1" className="platform-features">
                                    <strong>Features:</strong> {platform.features}
                                </Typography>
                                <UnifiedButton onClick={handleJoinNow} variant="outlined" className="learn-more-button" textContent={" Join Now"} />


                            </Grid>
                        </Grid>
                        {index < platforms.length - 1 && <Divider className="platform-divider" />}
                    </React.Fragment>
                ))}
            </Container>
        </section>
    );
};

export default MusicStreamingSecondSection;
